"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Promotions = void 0;
var Promotions_1 = require("./Promotions");
Object.defineProperty(exports, "Promotions", { enumerable: true, get: function () { return __importDefault(Promotions_1).default; } });
